import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators,FormGroupDirective} from '@angular/forms';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-add-business-users',
  templateUrl: './add-business-users.component.html',
  styleUrls: ['./add-business-users.component.scss']
})
export class AddBusinessUsersComponent implements OnInit {
  business:any;
  userForm:FormGroup
  business_name:any=''
  business_users:any=[]
  editId=""
  editStatus:boolean =false
  constructor(private router:Router, private observables:ObservablesService,private formBuilder: FormBuilder, private api:ApiService, private datePipe: DatePipe) {
    if(this.router.getCurrentNavigation().extras.state !== undefined){
      this.business = this.router.getCurrentNavigation().extras.state
      // console.log("business==",this.business)
      this.createForm()
      this.getBusinessUsers()
      this.api.send('findDb',{
        table:'roles',
        conditions:[{business_id:this.business.business_id}],
        order:["business_id ASC"]
      }).then((res:any)=>{
        if(res.data.length > 0){
          this.userForm.patchValue({role_id:res.data[0].id})
        }
      })
      this.business_name = this.business.business_name;
    }

  }

  ngOnInit() {

  }
  createForm(){
    this.userForm= this.formBuilder.group({
      business_id:[this.business.business_id,Validators.required],
      username:[null,Validators.required],
      password:[null,Validators.required],
      full_name:[null,Validators.required],
      role_id:[null,Validators.required]
    });
  }

  submitData(value,formDirective:FormGroupDirective){
    this.api.send("insertDb",{
      table:'users',
      data:value
    }).then((res:any)=>{
      if(res.data.affectedRows){
        formDirective.resetForm();
        this.userForm.reset()
        this.getBusinessUsers()
        this.observables.showToastMessage({type:0,message:'User saved..'});
      }else{
        if(res.data.code =="ER_DUP_ENTRY"){

          this.observables.showToastMessage({type:1,message:'User name already existed, Please try with other'});
        }else{

          this.observables.showToastMessage({type:1,message:'User not saved..'});
        }
      }
    })
  }

  getBusinessUsers(){
    this.api.send("findDb",{
      fields:["U.id","U.full_name","U.username","U.role_id","R.role"],
      table:"users as U",
      joins:[{
        type:"left",
        table:"roles as R",
        conditions:["R.id = U.role_id"]
      }],
      conditions:[{"U.business_id":this.business.business_id}],
      order:["U.id ASC"]
    }).then((res:any)=>{
      // console.log("users=",res)
      if(res.data.length > 0){

        this.business_users = res.data;
      }else{

      }
    })
  }

  getnum(value){
    return parseFloat(value)
  }

  cancel(formDirective:FormGroupDirective){
    formDirective.resetForm();
    this.userForm.reset()
    this.editStatus = false;
    this.editId = ''
    this.userForm.get('password').enable()
  }
  updateData(value,formDirective:FormGroupDirective){

    this.api.send("updateDb",{
      table:"users",
      data:{
        username:value.username,
        full_name:value.full_name
      },
      conditions:[{id:this.editId}]
    }).then((result:any)=>{
      if(result.data.affectedRows){
        formDirective.resetForm();
        this.userForm.reset()
        this.getBusinessUsers();
        this.editStatus = false;
        this.editId = ''
        this.userForm.get('password').enable()
        this.observables.showToastMessage({type:0, message:"User details Updated Successfully"})
      }else{
        this.observables.showToastMessage({type:1, message:"Some problem while updating user details, try again."})
      }
    })
  }


  deleteUser(id){
    if(confirm("Are you sure want to delete User?")){

      this.api.send("deleteDb",{
        table:"users",
        conditions:[{id:id}]
      }).then((result:any)=>{
        if(result.data.affectedRows){
          this.observables.showToastMessage({type:0, message:"User Deleted Successfully"})
          this.getBusinessUsers();
        }

      })
    }
  }

  editUser(user){
    this.userForm.patchValue({
      business_id:this.business.business_id,
      username:user.username,
      password:"abcdefghijklmnopqrstuvwxyz",
      full_name:user.full_name,
      role_id:user.role_id
    });
    this.userForm.get('password').disable()
    this.editStatus = true;
    this.editId = user.id;
  }

}
